import { createSelector } from 'reselect';
import { INIT_STATE } from '../../common/reducers/UserReducer';
import type { UserReducer, User, Settings } from '../../common/types/ts/userTypes';

export function getState(state: any): UserReducer {
  return (state && state.user) || INIT_STATE;
}

export const getUserData: (state: any) => User | undefined = createSelector(
  getState,
  (userState) => (userState && userState.data) || undefined
);

export const getLimitedUserData: (state: any) => any = createSelector(getUserData, (userData) => {
  if (!userData) {
    return undefined;
  }
  const { name, last_name, email } = userData;
  return { name, last_name, email };
});

export const selectIsAgencyUser = createSelector(getUserData, (user: User | undefined) => {
  return user ? Boolean(user.agency_user) : false;
});

export const isLoading: (state: any) => boolean = createSelector(getState, (state) => {
  return state.loading;
});

export const getUserAccessRoleId: (state: any) => number | undefined = createSelector(getState, (state) => {
  return state && state.access_role_id;
});

export const areSettingsLoading: (state: any) => boolean = createSelector(getState, (state) => {
  return (state && state.settingsLoading) || false;
});

export const getUserSettingsOrDefault: (state: any) => Settings = createSelector(getUserData, (state) => {
  return (state && state.settings) || {};
});

export const shouldAnalyticCalculateOrganic: (state: any) => boolean = createSelector(getUserSettingsOrDefault, (state) => {
  return (state && state.calculateAnalyticsOrganic) || false;
});

export const getUserEmail = createSelector(getUserData, (user: User | undefined) => {
  return user?.email || '';
});
